import { is } from "date-fns/locale";
import { ENV } from "../../../config";

const isDev = ENV !== "production";

console.log(isDev ? "Using DEV Stripe keys" : "Using PROD Stripe keys");

export const TIERS = [
  {
    credits: 1000,
    priceUsd: 49,
    priceId: isDev
      ? "price_1S85KpBfsKsdtVYaXpc9dQx9"
      : "price_1S8OasBfsKsdtVYaxkUmKOaE",
    hide: true,
  },
  {
    credits: 2500,
    priceUsd: 99,
    priceId: isDev
      ? "price_1S85KpBfsKsdtVYaZiWv13B8"
      : "price_1S8OasBfsKsdtVYap8fZot5b",
  },
  {
    credits: 5000,
    priceUsd: 149,
    priceId: isDev
      ? "price_1S85KqBfsKsdtVYar9tA6GyC"
      : "price_1S8OatBfsKsdtVYaQpcjJlos",
  },
  {
    credits: 10000,
    priceUsd: 249,
    priceId: isDev
      ? "price_1S85KqBfsKsdtVYatyO5fAn1"
      : "price_1S8OatBfsKsdtVYaHqGYYBqU",
  },
  {
    credits: 20000,
    priceUsd: 399,
    priceId: isDev
      ? "price_1S85KrBfsKsdtVYaAnoQkCg2"
      : "price_1S8OatBfsKsdtVYaIKg5d9Qy",
  },
  {
    credits: 40000,
    priceUsd: 599,
    priceId: isDev
      ? "price_1S85KrBfsKsdtVYa2KjQhH72"
      : "price_1S8OauBfsKsdtVYa2kzDEqsH",
  },
  {
    credits: 80000,
    priceUsd: 999,
    priceId: isDev
      ? "price_1S85KrBfsKsdtVYaYfHxHu0p"
      : "price_1S8OauBfsKsdtVYaTJo2TFRR",
  },
  {
    credits: 160000,
    priceUsd: 1499,
    priceId: isDev
      ? "price_1SvKC9BfsKsdtVYaKtVR9ipX"
      : "price_1SvKAvBfsKsdtVYa7hRGEipK",
  },
];
